$(function(){
    var qr=$(".qr-body-panel .qr");
    if(qr.length)
    {
        var qrCode=new QRCode(qr[0],{
            text:$("script#qrcodelink").text(),
            width: 210,
            height: 210,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.H
        });
        qr.attr("title","");
    }


});